<ngx-spinner size="large" type="ball-scale-multiple"></ngx-spinner>
